import React, { useEffect, useState } from "react";
import { useStateValue } from "../ContextAPI/StateProvider";
import ProgressBar from "./ProgressBar";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import axios from "axios";
import base_url from "./../../../api/bootapi";
// import Modal from "react-bootstrap/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const CustomerInformationForm = () => {
  // -------------->Variable Declaration<---------------------
  const classes = useStyles();
  // const [show, setShow] = useState(false);
  const [loader, setloader] = useState(false);
  const [value, setvalue] = useState(false);
  const [{ countries, states, timezone, serviceProvider }, dispatch] =
    useStateValue();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
    defaultValues: JSON.parse(sessionStorage.getItem("customerInformation")),
  });
  const [customerid, setcustomerid] = useState("");
  const [stateCust, setstateCust] = useState(
    JSON.parse(sessionStorage.getItem("customerInformation"))
  );
  const history = useHistory();
  // let canceltoken;
  // ---------->Functions<-----------
  // const handleShow = () => setShow(true);

  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    if (stateCust?.emailverified) {
      let obj = { ...stateCust };
      obj["shownextstep"] = false;
      obj["emailverified"] = false;
      obj["password"] = "";
      setstateCust(obj);
    }
  }, []);

  const handlephone = (e) => {
    let val = e.target.value;
    let name = e.target.name;
    if (val.length > 10 || Number.isNaN(Number(val))) return;
    setstateCust((prev) => {
      return {
        ...prev,
        [name]: val.trim(),
      };
    });
  };
  const checkemailexist = (val) => {
    setloader(true);
    axios.get(`${base_url}/info/check/email/${val}`).then((res) => {
      if (res.data.message === "User Already Exist") {
        let obj = { ...stateCust };
        obj["shownextstep"] = false;
        obj["emailverified"] = true;
        setstateCust(obj);
        // handleShow();
        setcustomerid(res.data?.user?.customer_id);
      } else {
        let obj = { ...stateCust };
        obj["shownextstep"] = true;
        obj["emailverified"] = false;
        sessionStorage.setItem("userexists", false);
        setstateCust(obj);
      }
      setloader(false);
    });
  };
  const inputEvent = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setstateCust((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const setstatefromcountry = (event) => {
    const index = event.target.selectedIndex;
    const optionElement = event.target.childNodes[index];
    const optionElementId = optionElement.getAttribute("id");

    axios
      .get(`${base_url}/info/country/${optionElementId}/states`)
      .then((res) => {
        dispatch({
          type: "ADD_TO_STATE",
          states: res.data.states,
        });
      });
  };
  const gettimezonedescription = (event) => {
    const index = event.target.selectedIndex;
    const optionElement = event.target.childNodes[index];
    const optionElementId = optionElement.getAttribute("id");
    stateCust.timezonedescription = optionElementId;
  };
  const submitcustomerinformation = (data2) => {
    if (!stateCust["emailverified"] && stateCust["shownextstep"]) {
      sessionStorage.setItem("customerInformation", JSON.stringify(stateCust));
      sessionStorage.setItem("movetoactivationpage", true);
      sessionStorage.setItem("userexists", false);
      sessionStorage.setItem("existingcards", JSON.stringify([]));
      history.push("/registration/activation-type");
    } else if (stateCust["emailverified"] && stateCust["password"]) {
      handleemailexist();
    } else {
      checkemailexist(data2["email"]);
    }
  };

  const submitwithoutpassword = () => {
    handleemailexist(false);
  };

  const checkdisable = () => {
    if (!(stateCust?.phone?.toString().length === 10)) {
      return true;
    }
    if (!value) {
      return true;
    }
    return false;
  };

  const handleemailexist = (flag = true) => {
    sessionStorage.setItem("userexists", true);
    sessionStorage.setItem("movetoactivationpage", true);
    sessionStorage.setItem("customerInformation", JSON.stringify(stateCust));
    history.push(`/registration/activation-type?customer_id=${customerid}`);
    if (flag) {
      axios
        .post(`${base_url}/auth/customer/cards`, {
          customer_id: customerid,
          password: stateCust["password"],
        })
        .then((res) => {
          if (res.data.status) {
            sessionStorage.setItem(
              "existingcards",
              JSON.stringify(res.data.cards)
            );
          } else {
            sessionStorage.setItem("existingcards", JSON.stringify([]));
          }
        })
        .catch((err) => {
          sessionStorage.setItem("existingcards", JSON.stringify([]));
        });
    } else {
      sessionStorage.setItem("existingcards", JSON.stringify([]));
    }
  };
  const handlepreviousbutton = () => {
    let obj = { ...stateCust };
    obj["shownextstep"] = false;
    setstateCust(obj);
  };
  return (
    <form id="myForm" onSubmit={handleSubmit(submitcustomerinformation)}>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <div>
        <ProgressBar typeofactive="Customer" />
        {!stateCust?.shownextstep ? (
          <div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-6">
                  <input
                    type="email"
                    {...register("email", {
                      required: true,
                      pattern: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/,
                      // pattern: /^[\w-\.]+@([\w-\.])$/,'
                    })}
                    value={stateCust?.email}
                    onChange={(e) => {
                      inputEvent(e);
                    }}
                    placeholder="Email"
                    className="form-control"
                    disabled={stateCust?.["emailverified"]}
                  />
                  {errors.email && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      Email is required
                    </span>
                  )}
                </div>
                {stateCust?.emailverified ? (
                  <div className="col-md-6">
                    <input
                      type="password"
                      {...register("password", { required: true })}
                      value={stateCust?.password}
                      onChange={inputEvent}
                      placeholder="Password"
                      className="form-control"
                    />
                    <span
                      className="text-info d-block text-left"
                      style={{ fontSize: "13px" }}
                    >
                      *Use your existing amcrestgps password
                    </span>
                    {errors.password && (
                      <span className="errormessage">
                        <span>
                          <i
                            className="fa fa-times errorifont"
                            aria-hidden="true"
                          ></i>
                        </span>
                        Password is required
                      </span>
                    )}
                  </div>
                ) : (
                  <div className="col-md-6">
                    <button className="btn btn-primary w-100" type="submit">
                      Next
                    </button>
                  </div>
                )}
              </div>
              {stateCust?.emailverified && (
                <div className="row">
                  <div className="col-md-6">
                    <button className="btn btn-primary w-100" type="submit">
                      Continue with Password
                    </button>
                  </div>
                  <div className="col-md-6">
                    <button
                      className="btn btn-primary w-100"
                      onClick={submitwithoutpassword}
                    >
                      Continue without Password
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-6">
                  <input
                    type="email"
                    value={stateCust?.email}
                    placeholder="Email"
                    className="form-control"
                    readOnly={true}
                  />
                  {errors.email && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      Email is required
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-6">
                  <input
                    type="password"
                    {...register("password", { required: true })}
                    value={stateCust?.password}
                    onChange={inputEvent}
                    placeholder="Password"
                    className="form-control"
                  />
                  {errors.password && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      Password is required
                    </span>
                  )}
                </div>
                <div className="col-md-6">
                  <input
                    type="password"
                    {...register("confirmPassword", { required: true })}
                    value={stateCust?.confirmPassword}
                    onChange={inputEvent}
                    placeholder="Confirm Password"
                    className="form-control"
                  />
                  {errors.confirmPassword && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      Confirm Password is required
                    </span>
                  )}
                  {stateCust?.confirmPassword &&
                    stateCust?.confirmPassword !== stateCust?.password && (
                      <p className="errormessage marginp">
                        <span>
                          <i
                            className="fa fa-times errorifont"
                            aria-hidden="true"
                          ></i>
                        </span>
                        Password not matching
                      </p>
                    )}
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-6">
                  <input
                    type="text"
                    {...register("firstName", { required: true })}
                    value={stateCust?.firstName}
                    onChange={inputEvent}
                    placeholder="First Name"
                    className="form-control"
                  />
                  {errors.firstName && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      FirstName is required
                    </span>
                  )}
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    {...register("lastName", { required: true })}
                    value={stateCust?.lastName}
                    onChange={inputEvent}
                    placeholder="Last Name"
                    className="form-control"
                  />
                  {errors.lastName && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      LastName is required
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="form-group">
              <div className="row">
                <div className="col-md-12">
                  <input
                    type="text"
                    {...register("companyName")}
                    value={stateCust?.companyName}
                    onChange={inputEvent}
                    className="form-control"
                    placeholder="Company Name"
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-12">
                  <input
                    type="text"
                    {...register("billingAddress", { required: true })}
                    value={stateCust?.billingAddress}
                    onChange={inputEvent}
                    className="form-control"
                    placeholder="Billing Address"
                  />
                  {errors.billingAddress && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>{" "}
                      Billing Address is required
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-6">
                  <select
                    {...register("country", { required: true })}
                    value={stateCust?.country}
                    onChange={(e) => {
                      setstatefromcountry(e);
                      inputEvent(e);
                    }}
                    className="form-control"
                  >
                    <option value="">SELECT COUNTRY</option>
                    {countries?.map((item) => (
                      <option
                        key={item.id}
                        id={item.id}
                        value={item.country_name}
                      >
                        {item.country_name}
                      </option>
                    ))}
                  </select>
                  {errors.country && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      Country is required
                    </span>
                  )}
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    {...register("city", { required: true })}
                    value={stateCust?.city}
                    onChange={inputEvent}
                    className="form-control"
                    placeholder="City"
                  />
                  {errors.city && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      City is required
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-6">
                  {states?.length > 0 ? (
                    <select
                      {...register("state", { required: true })}
                      value={stateCust?.state}
                      onChange={inputEvent}
                      className="form-control"
                    >
                      <option value="">SELECT STATES</option>
                      {states?.map((item) => (
                        <option key={item.id} value={item.state_name}>
                          {item.state_name}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      {...register("state", { required: true })}
                      value={stateCust?.state}
                      onChange={inputEvent}
                      className="form-control"
                      placeholder="SELECT STATE"
                    />
                  )}
                  {errors.state && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      State is required
                    </span>
                  )}
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    {...register("zipcode", { required: true })}
                    value={stateCust?.zipcode}
                    onChange={inputEvent}
                    className="form-control"
                    placeholder="Zip Code"
                  />
                  {errors.zipcode && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      ZipCode is required
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-12">
                  <select
                    {...register("timezone", { required: true })}
                    value={stateCust?.timezone}
                    onChange={(e) => {
                      gettimezonedescription(e);
                      inputEvent(e);
                    }}
                    className="form-control"
                  >
                    <option value="">SELECT TIME ZONE</option>
                    {timezone?.map((item) => (
                      <option
                        key={item.id}
                        value={item.time_zone}
                        id={item.description}
                      >
                        {item.description}
                      </option>
                    ))}
                  </select>
                  {errors.timezone && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      TimeZone is required
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-6">
                  <select
                    {...register("serviceProvider", { required: true })}
                    value={stateCust?.serviceProvider}
                    onChange={(e) => {
                      inputEvent(e);
                      stateCust.customserviceProvider = "";
                    }}
                    className="form-control"
                  >
                    <option value="">SELECT MOBILE CARRIER</option>
                    {serviceProvider?.map((item) => (
                      <option key={item.id} value={item.mobile_provider_name}>
                        {item.mobile_provider_name}
                      </option>
                    ))}
                  </select>
                  {errors.serviceProvider && (
                    <span className="errormessage">
                      <span>
                        <i
                          className="fa fa-times errorifont"
                          aria-hidden="true"
                        ></i>
                      </span>
                      Service Provider is required
                    </span>
                  )}
                </div>
                {stateCust?.serviceProvider === "Others" && (
                  <div className="col-md-6">
                    <input
                      {...register("customserviceProvider", { required: true })}
                      placeholder="Enter Custom Mobile Carrier"
                      className="form-control"
                      type="text"
                      value={stateCust?.customserviceProvider}
                      onChange={inputEvent}
                    />
                    {errors.customserviceProvider && (
                      <span className="errormessage">
                        <span>
                          <i
                            className="fa fa-times errorifont"
                            aria-hidden="true"
                          ></i>
                        </span>
                        Mobile Carrier is required
                      </span>
                    )}
                  </div>
                )}
                <div className="col-md-6">
                  <input
                    type="text"
                    {...register("phone", {
                      required: true,
                      maxLength: 10,
                    })}
                    value={stateCust?.phone}
                    onChange={handlephone}
                    className="form-control"
                    placeholder="Phone"
                  />
                  <p className="phone_instruction marginp">
                    *Phone should be 10 digit without country code and hyphen!
                  </p>
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        if (e.target.checked) {
                          setvalue(true);
                        } else {
                          setvalue(false);
                        }
                      }}
                      style={{ marginRight: "5px", marginTop: "7px" }}
                    />
                    <p className="phone_instruction2">
                      By checking this box, you are choosing to receive SMS
                      alerts from Amcrest Industries LLC.
                    </p>
                  </div>
                  {/* <p className="phone_instruction2">
                    * By providing your phone number, you are opting in to
                    receive SMS alerts from{" "}
                    <a
                      target="_blank"
                      href="https://amcrestgps.net/terms/"
                      rel="noreferrer"
                      className="termslink"
                    >
                      amcrestgps.net.
                    </a>
                  </p> */}
                </div>
              </div>
            </div>
            <div
              className="activation"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <button
                className="btn "
                style={{ backgroundColor: "#ccc", borderColor: "#ccc" }}
                onClick={handlepreviousbutton}
              >
                Previous
              </button>
              <button
                // disabled={!isValid || !stateCust?.phone}
                disabled={checkdisable()}
                className={
                  "btn btn-primary"
                  // !isValid ? "btn btn-primary buttondisabled" : "btn btn-primary"
                }
                type="submit"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
      {/* <Modal backdrop="static" show={show}>
        <Modal.Header>
          <Modal.Title>Email Exist!!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          This email already exists : {stateCust?.email}!! We are taking you to
          next step.
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={handleemailexist}>
            Ok
          </button>
        </Modal.Footer>
      </Modal> */}
    </form>
  );
};

export default CustomerInformationForm;
